module.exports = __webpack_public_path__ + "static/media/Subtract 3.f4bdbe22.png";